import { Component } from "@angular/core";
import { slideToBottomTransition } from "../../animations";
import { UserService } from "@app/services/user.service";
import { ActivatedRoute } from "@angular/router";
import { CouponService } from "@app/services/coupon.service";
import { User } from "@app/data/user";

declare var $zoho;

@Component({
  templateUrl: "./platform.component.html",
  animations: [slideToBottomTransition],
})
export class PlatformComponent {
  hideNav: boolean;
  hasAccessToCatalogBuilder: boolean = false;
  hasAccessToGIFMaker: boolean = false;
  hasAccessToTearSheet: boolean = false;
  subscription;
  activeMenu: string;
  coupon: any;
  coupons: any[];
  showFlashSale: boolean = false;
  discountCoupon: string;
  user: User;
  isTrial: boolean = true;
  isShopify: boolean = false;
  showDaysLeft: boolean = false;
  daysLeft: number = 0;
  isBetaUser: boolean = false;
  showFoldsquareAnnouncement: boolean =
    localStorage.getItem("fs_announcement_dismissed") !== "1";

  countDownConfig = {};

  dateDiffInDays(a, b) {
    // Discard the time and time-zone information.
    var _MS_PER_DAY = 1000 * 60 * 60 * 24;
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }

  constructor(
    couponService: CouponService,
    private userService: UserService,
    private route: ActivatedRoute
  ) {
    this.userService.me().then((user) => {
      this.user = user;
      this.isBetaUser = user.roles?.includes("beta_user") || user.roles?.includes("beta_tester");
      this.subscription = user.subscription;
      this.isTrial = this.subscription.is_trial;
      this.isShopify = this.userService.isShopify(user);
      if (this.subscription) {
        var startDate = new Date(this.subscription.start_date);
        var endDate = new Date(startDate);
        if (this.subscription.duration) {
          endDate.setDate(startDate.getDate() + this.subscription.duration);
          var daysLeft = this.dateDiffInDays(new Date(), endDate);
          this.daysLeft = daysLeft > 0 ? daysLeft : 0;
          this.showDaysLeft = true;
        }
      }
      // if (this.isTrial) {
      //   this.initCoupons();
      // }
    });

    this.userService.hasAccess("catalog-builder").then((hasAccess) => {
      this.hasAccessToCatalogBuilder = hasAccess;
    });
    this.userService.hasAccess("gif-maker").then((hasAccess) => {
      this.hasAccessToGIFMaker = hasAccess;
    });
    this.userService.hasAccess("tear-sheet").then((hasAccess) => {
      this.hasAccessToTearSheet = hasAccess;
    });
    this.route.queryParams.subscribe((params) => {
      this.hideNav = params.hideNav;
      if (this.hideNav) {
        const interval = setInterval(() => {
          if ($zoho && $zoho.salesiq && $zoho.salesiq.floatbutton) {
            clearInterval(interval);
            $zoho.salesiq.floatbutton.visible("hide");
          }
        }, 1000);
      }
    });
  }

  // initCoupons() {
  //   this.couponService.query().then(coupons => {
  //     this.coupons = coupons;
  //     this.checkCouponValidty();
  //   });
  // }

  // checkCouponValidty() {
  //   console.log(this.user);
  //   if (this.user.stripe_coupon_id) {
  //     this.coupon = this.coupons[this.user.stripe_coupon_id];
  //     if (this.coupon && this.coupon.valid) {
  //       this.discountCoupon = this.user.stripe_coupon_id;
  //       this.showFlashSale = true;
  //       this.countDownConfig['stopTime'] = this.coupon.redeem_by*1000;
  //       this.countDownConfig['template'] = '$!h! hr $!m! mn $!s! s';
  //     }
  //   } else {
  //     this.couponService.create().then(coupon => {
  //       this.user.stripe_coupon_id = coupon.id;
  //       this.userService.me().then(user => {
  //         this.user = user;
  //         this.initCoupons();
  //       })
  //     });
  //   }
  // };

  selectActiveMenu(activeMenu: string) {
    this.activeMenu = activeMenu;
  }

  dismissFoldsquareAnnouncement(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    localStorage.setItem("fs_announcement_dismissed", "1");
    this.showFoldsquareAnnouncement = false;
  }

  // change the animation state
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }
}
